// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3A7dp","rootMobile":"styles_rootMobile__imrAE"};